import {alertService} from "../../services/AlertService";

export function createNotification(type, msg) {
    alertService.success(msg, {
        autoClose: true,
        keepAfterRouteChange: false,
    });

}

